import moment from 'moment';

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_DESC = 'Do MMM, YYYY';

export const momentUpdateLocale = (lang, config) => moment.updateLocale(lang, config);

export const dateToday = () => moment();

// Dates format
export const dateToString = (val, format = DATE_FORMAT_DESC) =>
  val ? moment(val).format(format) : '';

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const isoToDate = (val, format = DATE_FORMAT_ISO) =>
  val ? moment(val, format).format(DATE_FORMAT_DEFAULT) : '';

export const calendar = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).calendar() : '';
